module.exports = __webpack_public_path__ + "assets/a-6-jiancebi.6eef5ca4.svg";